export class SalesNetwork {
  public id?: number;
  public code: string;
  public name: string;
  public description: string;
  public logo_name: string;
  public logo: string;
  public source_system_id?: number;
  public company_host_code?: string;
}



// WEBPACK FOOTER //
// ./src/app/models/sales-network.model.ts